import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, Copy } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleAI({ moduleKey, item, label, onRefresh }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mod/${moduleKey}/items/${item.id}/ai`);
      setText(data.text);
      toast.success("Generado con IA");
      onRefresh?.();
    } catch (err) { toast.error(err?.response?.data?.detail || "No se pudo generar"); }
    finally { setBusy(false); }
  };
  const copy = () => { navigator.clipboard.writeText(text); toast.success("Copiado"); };

  // show previously stored AI output if any known field is present
  const stored = text || item.contenido || item.mensaje || item.articulo || item.respuesta ||
    item.minuta || item.insight || item.resumen_ia || item.reporte_ia || item.ideas || item.flujo ||
    item.config_ia || item.plan || item.guion || "";

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-ai">
      <div className="flex items-center justify-between gap-2">
        <div className="overline text-navy/40">Asistente IA</div>
        <button onClick={run} disabled={busy} className="btn btn-primary" data-testid="ai-generate-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {label || "Generar con IA"}
        </button>
      </div>
      {busy && !stored && (
        <div className="space-y-2 animate-pulse" data-testid="ai-loading">
          <div className="h-3 rounded bg-navy/10 w-3/4" /><div className="h-3 rounded bg-navy/10 w-full" /><div className="h-3 rounded bg-navy/10 w-5/6" />
          <p className="text-xs text-navy/40">Generando con IA…</p>
        </div>
      )}
      {stored && (
        <div className="relative" data-testid="ai-output">
          <button onClick={copy} className="absolute top-2 right-2 text-navy/30 hover:text-violet" title="Copiar"><Copy className="w-4 h-4" /></button>
          <pre className="text-sm text-navy/75 bg-navy/[0.03] rounded-lg p-3 whitespace-pre-wrap max-h-72 overflow-y-auto">{stored}</pre>
        </div>
      )}
    </div>
  );
}
